import { Middleware } from '@reduxjs/toolkit';
import { authApi } from '../api/authApi';
import { clientsApi } from '../api/clientsApi';
import { userApi } from '../api/userApi';
import { providersApi } from '../api/providersApi';
import { endpointsApi } from '../api/endpointsApi';
import { organizationsApi } from '../api/organizationsApi';
import { businessSystemsApi } from '../api/businessSystemsApi';
import { logsApi } from '../api/logsApi';
import { certificatesApi } from '../api/certificatesApi';
import { managementClientsApi } from '../api/managementClientsApi';

export const logoutMiddleware: Middleware = (store) => (next) => (action) => {
  // Check if this is a logout action
  if ((action as any).type === 'auth/logout') {
    // Clear all RTK Query API caches BEFORE processing logout
    // This prevents any race conditions with auth token removal
    store.dispatch(authApi.util.resetApiState());
    store.dispatch(clientsApi.util.resetApiState());
    store.dispatch(userApi.util.resetApiState());
    store.dispatch(providersApi.util.resetApiState());
    store.dispatch(endpointsApi.util.resetApiState());
    store.dispatch(organizationsApi.util.resetApiState());
    store.dispatch(businessSystemsApi.util.resetApiState());
    store.dispatch(logsApi.util.resetApiState());
    store.dispatch(certificatesApi.util.resetApiState());
    store.dispatch(managementClientsApi.util.resetApiState());
    
    // Clear session storage if any
    if (typeof window !== 'undefined') {
      sessionStorage.clear();
    }
  }
  
  // Continue with the action
  return next(action);
};